type RememberToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function RememberToggle({ checked, onChange }: RememberToggleProps) {
  return (
    <label className="flex cursor-pointer select-none items-center gap-3 text-body-md text-on-surface-variant">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="size-5 cursor-pointer rounded accent-primary-container"
      />
      Keep me signed in on this device
    </label>
  );
}